import React, { useState }from 'react'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ContactForm = () => {
    const [user, setUser] = useState({name: "", email:"", subject:"", message:""});
    const history = useNavigate();
          
    let name, value;
    const handleInput = (e) =>{
        name = e.target.name;
        value = e.target.value;
    
        setUser({...user,[name]:value});
    }


    const FormSubmit = async(e) =>{
        e.preventDefault();
    const { name, email, subject, message} = user;
    if(name ==='' || email===''|| subject===''|| message === '' ){
       return toast.warning('Please fill the form properly....')
    }

        const res = await fetch('https://ozwidecover-backend.vercel.app/api/contact', {
            method:'POST',
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({name:name, email:email, subject:subject, message:message})
        })

        const data = await res.json();

        if(res.status === 422 || !data){
            toast.error('Invalid Details...')
        }
        else{
            toast.success('Query submitted successfully...')
            history('/');
        }
}
  return (
    <div>
      <form onSubmit={FormSubmit}>
            <div className="relative mb-6" data-te-input-wrapper-init>
              <input type="text" className="peer block min-h-[auto] w-full rounded border-2 bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none " id="exampleInput90" name='name' value={user.name} onChange={handleInput} required />
              <label className="pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none " htmlFor="exampleInput90">Name</label>
            </div>
            <div className="relative mb-6" data-te-input-wrapper-init>
              <input type="email" className="peer block min-h-[auto] w-full rounded border-2 bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none " id="exampleInput91" name='email' value={user.email} onChange={handleInput} required/>
              <label className="pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none " htmlFor="exampleInput91">Email address
                </label>
            </div>
            <div className="relative mb-6" data-te-input-wrapper-init>
              <input type="text" className="peer block min-h-[auto] w-full rounded border-2 bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none " id="exampleInput91" name='subject' value={user.subject} onChange={handleInput} required/>
              <label className="pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none " htmlFor="exampleInput91">Subject
                </label>
            </div>
            <div className="relative mb-6" data-te-input-wrapper-init>
              <textarea className="peer block min-h-[auto] w-full rounded border-2 bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none " id="exampleFormControlTextarea1" rows="3" name='message' value={user.message} onChange={handleInput} required></textarea>
              <label htmlFor="exampleFormControlTextarea1" className="pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6] text-neutral-500 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none ">Message</label>
            </div>
            <button type="submit" className="mb-6 w-full roundfull bg-yellow-500 text-white px-6 pt-2.5 pb-2 text-xs font-medium uppercase leading-normal hover:bg-yellow-700  lg:mb-0">Send</button>
          </form>
    </div>
  )
}

export default ContactForm
